import { toMoney } from '../../../../utils/common.utils';
import Whisper from 'rsuite/Whisper';
import React from 'react';
import {
  CleanCustomsDeliveryOrderGood,
  RbacObject,
} from '../../../../export-types/cleaned-types';
import Popover from 'rsuite/Popover';
import Dropdown from 'rsuite/Dropdown';
import { Rbac } from '../../../common/Rbac';
import { trpcSwr } from '../../../../api/trpc';
import { ModalsService } from '../../../../services/modals.service';
import { CustomsDeliveryOrderGoodEditModal } from './customs-delivery-order-good-edit-modal';

export const CustomsDeliveryOrderGoodItem = ({
  good,
  customsDeliveryOrderId,
  onDelete,
  onUpdate,
}: {
  good: CleanCustomsDeliveryOrderGood;
  customsDeliveryOrderId: string;
  onDelete: () => void;
  onUpdate: () => void;
}) => {
  const { trigger: deleteGood } =
    trpcSwr.customsDelivery.deleteGoodToOrder.useSWRMutation();
  const { trigger: updateGood } =
    trpcSwr.customsDelivery.updateGoodToOrderByAdmin.useSWRMutation();

  const speaker = (
    { onClose, left, top, className }: any,
    ref: React.Ref<any>,
  ) => (
    <Popover ref={ref} className={className} style={{ left, top }} full>
      <Dropdown.Menu>
        <Rbac object={RbacObject.CustomsDelivery} action={'write'}>
          <Dropdown.Item
            onSelect={async function () {
              onClose();
              await deleteGood({
                goodId: good.id,
                customsDeliveryOrderId: customsDeliveryOrderId,
              });
              onDelete();
            }}
          >
            <i className="bi bi-trash" />
            <span className="ps-2">Удалить</span>
          </Dropdown.Item>
          <Dropdown.Item
            onSelect={function () {
              onClose();
              ModalsService.createModal(CustomsDeliveryOrderGoodEditModal, {
                defaultValues: good,
                onSubmit: async (data) => {
                  await updateGood({
                    good: data,
                    goodId: good.id,
                    customsDeliveryOrderId: customsDeliveryOrderId,
                  });
                  onUpdate();
                },
              });
            }}
          >
            <i className="bi bi-pencil" />
            <span className="ps-2">Изменить</span>
          </Dropdown.Item>
        </Rbac>
      </Dropdown.Menu>
    </Popover>
  );
  return (
    <div className={'d-flex rounded w-100 bg-gray-50 p-2 fs-14'}>
      <div>
        <div>{good.name}</div>
        <div className={' color-gray-450 d-flex gap-5'}>
          <div> {good.codeTariff}</div>
          <div>
            Общая стоимость: {toMoney(good.price || 0, good.currency || '')}
          </div>
          <div> Таможенная пошлина: {toMoney(good.tollsSum || 0, 'rub')}</div>
        </div>
      </div>
      <div className={'mleft-auto'}>
        <Whisper placement="bottomEnd" trigger="click" speaker={speaker}>
          <button className="btn btn-link text-decoration-none">
            <i className="bi bi-three-dots" />
          </button>
        </Whisper>
      </div>
    </div>
  );
};
